import React, { useState } from "react";
import iso from "../../assets/images/iso.webp";
import nabl from "../../assets/images/nabl.webp";
import purity from "../../assets/images/purity.webp";
import manufacturing from "../../assets/images/manufacturing.webp";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';

const ChooseSection = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });

  const [isExpanded, setIsExpanded] = useState(false);

const text = `At Elementeers, we specialize in providing high-quality, precisely formulated laboratory chemicals and standards designed to support accurate trace element analysis and advanced chemical testing across a wide array of industries. Our products are crafted to meet the strictest quality and consistency standards, ensuring reliable and reproducible results in critical applications such as research, quality control, and regulatory compliance. We understand the importance of precision in analytical processes, which is why our chemicals are tailored to enhance accuracy in detecting trace elements, maintaining optimal conditions, and optimizing testing procedures. Whether for pharmaceutical research, environmental monitoring, biotechnology, or chemical manufacturing, our solutions help drive innovation, improve operational efficiency, and ensure regulatory adherence, empowering our clients to achieve superior results every time.`;

  const wordLimit = 70;

  const words = text.split(" ");
  const shouldTruncate = words.length > wordLimit;

  const displayText = isExpanded
    ? text
    : words.slice(0, wordLimit).join(" ") + (shouldTruncate ? "..." : "");
  return (
    <div>
      <div className="funfacts-area ptb-80">
        <div className="container">
          <div className="row">
            <div
              className={`col-lg-6 col-md-3 aos-init aos-animate box-animate ${inView1 ? 'visible' : ''}`} ref={ref1}
            >
              <div className="choose-us">
                <h2>Why Choose Us</h2>
                {/* <p>At Elementeers, we specialize in providing high-quality, precisely formulated laboratory chemicals and standards designed to support accurate trace element analysis and advanced chemical testing across a wide array of industries. Our products are crafted to meet the strictest quality and consistency standards, ensuring reliable and reproducible results in critical applications such as research, quality control, and regulatory compliance. We understand the importance of precision in analytical processes, which is why our chemicals are tailored to enhance accuracy in detecting trace elements, maintaining optimal conditions, and optimizing testing procedures. Whether for pharmaceutical research, environmental monitoring, biotechnology, or chemical manufacturing, our solutions help drive innovation, improve operational efficiency, and ensure regulatory adherence, empowering our clients to achieve superior results every time.</p> */}
               <p>
                  {displayText}{" "}
                  {shouldTruncate && (
                    <button
                      onClick={() => setIsExpanded(!isExpanded)}
                      style={{
                        color: "#000",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: 0
                      }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </p>
                <Link
                  to={`${config.appUrl}about-us`}
                  className="btn choose-btn aos-init aos-animate"
                >Know More</Link>
              </div>
            </div>
            <div
              className={`col-lg-6 col-md-3 aos-init aos-animate box-animate ${inView1 ? 'visible' : ''}`} ref={ref1}
            >
              <div className="choose-img">
                <div className="row">
                  <div className="col-md-6 d-flex align-items-center iso-img">
                    <img src={iso} />
                    <h5>Precision & Quality</h5>
                  </div>
                  <div className="col-md-6 d-flex align-items-center iso-img">
                    <img src={nabl} />
                    <h5>Expertise & Experience</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 d-flex align-items-center iso-img">
                    <img src={purity} />
                    <h5>Global Reach</h5>
                  </div>
                  <div className="col-md-6 d-flex align-items-center iso-img">
                    <img src={manufacturing} />
                    <h5>Customer-Centric Approach</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseSection;
